import { useContext, } from 'react';

import CompanyContext from '../contexts/company';

export default _ => useContext(CompanyContext);
